define('app-Blog/main',['./settings', 'bxslider', 'hoverIntent'], function (settings) {

    return {
        run: function () {
            var self = this;
            self.settings = settings;
            if ($(settings.container).length === 0) {
                window.log('No megaBlog div located. megaBlog will not be available');
                return;
            }


            /*Show count and hide load more*/
            function countBlogs() {
                var numItems = $('.blogentries .blogEntry').length;
                var totalItems = $('.blogCount .totalCount').text();
                $('.blogCount .currentCount').text(numItems);
                if (numItems >= totalItems) {
                    $('#loadMore').hide();
                }
            }

            //Search
            $("#submitSearch, .magnify, .searchBar span").click(function (e) {
                e.preventDefault();
                searchBlogs();
            });
            $('.blogInput ').on('keypress', function (e) {
                if (e.which === 13) {
                    searchBlogs();
                }
            });

            function searchBlogs() {
                $('#getPageType').attr('value', 'getsearchresultsblogs');
                var sectionElement = "";

                if (event.target.id == "clearInput") {
                    $(".blogInput").val('');
                }

                sectionElement = $(this),
                    keywordInput = $(".blogInput").val().replace(/[^a-z]/g, ''),
                    section = $(".searchBar").attr('data-id'),
                    sectionName = $(".searchBar label span").text(),
                    cruise = true,
                    dataToBeSend = {
                        keyword: keywordInput,
                        count: 0,
                        section: section,
                        cruise: cruise
                    };




                $('#loadMore').show();
                if (keywordInput != "") {
                    $.ajax({
                        url: "/blogfilter/" + "getsearchresultsblogs",
                        type: "post",
                        data: JSON.stringify(dataToBeSend),
                        dataType: "json",
                        contentType: "application/json",
                        success: function (responseData) {
                            if (responseData.blogResults.length !== 0) {
                                var result = '';
                                for (var i = 0; i < responseData.blogResults.length; i++) {
                                    result += ($('#blogEntry-template').html()
                                        .replace("{{url}}", responseData.blogResults[i].blogUrl)
                                        .replace("{{imageCaption}}", responseData.blogResults[i].imageCaption != null ? responseData.blogResults[i].imageCaption : "")
                                        .replace("{{imageurl}}", responseData.blogResults[i].blogDefaultUrl != null ? responseData.blogResults[i].blogDefaultUrl : "")
                                        .replace("{{blogIcon}}", responseData.blogResults[i].blogTitleIcon != null ? responseData.blogResults[i].blogTitleIcon : "")
                                        .replace("{{blogtitle}}", responseData.blogResults[i].blogTitle)
                                        .replace("{{date}}", responseData.blogResults[i].dateString)
                                        .replace("{{title}}", responseData.blogResults[i].title)
                                        .replace("{{teaser}}", responseData.blogResults[i].teaser)
                                        .replace("{{buttonurl}}", responseData.blogResults[i].blogUrl)
                                        .replace("{{hidedate}}", responseData.blogResults[i].hideDateClass));

                                }

                            } else {
                                $('#loadMore').hide();
                            }

                            if (responseData.blogCount !== 0) {
                                $('.totalCount').html(responseData.blogCount);
                            }
                            $('.featureEntries, .featureEntriesCruise').empty();
                            $(".blogentries li").remove();
                            $(result).hide().appendTo(".blogentries ul").fadeIn(1000);
                            countBlogs();


                        },
                        error: function () {
                            alert("Sorry, there is a problem retrieving anymore blog entries!");
                            $('#loadingButton').hide();
                        }
                    });

                } else {
                    var dataToBeSend = {
                        keyword: "",
                        count: 0,
                        section: section,
                        cruise: cruise
                    };
                    $.ajax({
                        url: "/blogfilter/" + "getsearchresultsblogs",
                        type: "post",
                        data: JSON.stringify(dataToBeSend),
                        dataType: "json",
                        contentType: "application/json",
                        success: function (responseData) {
                            if (responseData.blogResults.length !== 0) {
                                var result = '';
                                for (var i = 0; i < responseData.blogResults.length; i++) {
                                    result += ($('#blogEntry-template').html()
                                        .replace("{{url}}", responseData.blogResults[i].blogUrl)
                                        .replace("{{imageCaption}}", responseData.blogResults[i].imageCaption != null ? responseData.blogResults[i].imageCaption : "")
                                        .replace("{{imageurl}}", responseData.blogResults[i].blogDefaultUrl != null ? responseData.blogResults[i].blogDefaultUrl : "")
                                        .replace("{{blogtitle}}", responseData.blogResults[i].blogTitle)
                                        .replace("{{blogIcon}}", responseData.blogResults[i].blogTitleIcon != null ? responseData.blogResults[i].blogTitleIcon : "")
                                        .replace("{{date}}", responseData.blogResults[i].dateString)
                                        .replace("{{title}}", responseData.blogResults[i].title)
                                        .replace("{{teaser}}", responseData.blogResults[i].teaser)
                                        .replace("{{buttonurl}}", responseData.blogResults[i].blogUrl)
                                        .replace("{{hidedate}}", responseData.blogResults[i].hideDateClass));

                                }
                            } else {
                                $('#loadMore').hide();
                            }
                            $(".blogentries li").remove();
                            $(result).hide().appendTo(".blogentries ul").fadeIn(1000);

                            $('.totalCount').html($('.totalCount').attr('data-totalCount'));
                            countBlogs();

                        },
                        error: function () {
                            alert("Sorry, there is a problem retrieving anymore blog entries!");
                            $('#loadingButton').hide();
                        }
                    });
                }


                $('#submitSearch').val([$('.inputSearch').val()]);
                $('.inputSearch').val("");
                $('.blogPageTitle').html('Search results for "' + $(".blogInput").val().replace(/[^a-z]/g, '') + '"');
                $('.featureEntriesCruise').hide();


            }

            $("#loadMore a").click(function () {
                $('#loadMore').hide();
                $('#loadingButton').css("display", "table");

                var pageType = $('#getPageType').attr('value');
                var dataToBeSend = "";

                dataToBeSend = {
                    keyword: $(".blogInput").val().replace(/[^a-z]/g, ''),
                    count: $('.blogEntry').length,
                    section: $(".searchBar").attr('data-id'),
                    pageId: $('#getPageType').attr('pageId'),
                    cruise: true
                };



                $.ajax({
                    url: "/BlogFilter/" + pageType,
                    type: "post",
                    data: JSON.stringify(dataToBeSend),
                    dataType: "json",
                    contentType: "application/json",
                    success: function (responseData) {
                        if (responseData.blogResults.length !== 0) {
                            var result = '';
                            for (var i = 0; i < responseData.blogResults.length; i++) {
                                result += ($('#blogEntry-template').html()
                                    .replace("{{url}}", responseData.blogResults[i].blogUrl)
                                    .replace("{{imageCaption}}", responseData.blogResults[i].imageCaption != null ? responseData.blogResults[i].imageCaption : "")
                                    .replace("{{imageurl}}", responseData.blogResults[i].blogDefaultUrl != null ? responseData.blogResults[i].blogDefaultUrl : "")
                                    .replace("{{blogtitle}}", responseData.blogResults[i].blogTitle)
                                    .replace("{{blogIcon}}", responseData.blogResults[i].blogTitleIcon != null ? responseData.blogResults[i].blogTitleIcon : "")

                                    .replace("{{date}}", responseData.blogResults[i].dateString)
                                    .replace("{{title}}", responseData.blogResults[i].title)
                                    .replace("{{teaser}}", responseData.blogResults[i].teaser)
                                    .replace("{{buttonurl}}", responseData.blogResults[i].blogUrl)
                                    .replace("{{hidedate}}", responseData.blogResults[i].hideDateClass));
                            }
                            $(".blogentries ul").append(result);
                            $('#loadingButton').hide();
                            $('#loadMore').show();

                            countBlogs();
                        }
                        else {
                            $('#loadMore').hide();
                            $('#loadingButton').hide();
                        }
                    },
                    error: function () {
                        alert("Sorry, there is a problem retrieving anymore blog entries!");
                    }
                });


            });

            $(".getMonthName").each(function () {
                var monthNumber = $(this).attr('month');
                var monthName = "";
                if (monthNumber == "1") {
                    monthName = "January";
                }
                if (monthNumber == "2") {
                    monthName = "February";
                }
                if (monthNumber == "3") {
                    monthName = "March";
                }
                if (monthNumber == "4") {
                    monthName = "April";
                }
                if (monthNumber == "5") {
                    monthName = "May";
                }
                if (monthNumber == "6") {
                    monthName = "June";
                }
                if (monthNumber == "7") {
                    monthName = "July";
                }
                if (monthNumber == "8") {
                    monthName = "August";
                }
                if (monthNumber == "9") {
                    monthName = "September";
                }
                if (monthNumber == "10") {
                    monthName = "October";
                }
                if (monthNumber == "11") {
                    monthName = "November";
                }
                if (monthNumber == "12") {
                    monthName = "December";
                }
                $(this).html(monthName);
            });

            $(".getDaySuffix").each(function (i) {
                var day = $(this).attr('day');
                var suffix = "";
                if (day == "1" || day == "21" || day == "31") {
                    suffix = "st";
                }
                else if (day == "2" || day == "22") {
                    suffix = "nd";
                }
                else if (day == "3" || day == "23") {
                    suffix = "rd";
                }
                else {
                    suffix = "th";
                }
                $(this).html(day + suffix);
            });

            $('.accordion-toggle').click(function (e) {
                e.preventDefault();
                var associatedTab = $('#' + $(this).attr('rel'));
                var parent = associatedTab.parent('.accordion-group');
                if (associatedTab.is(':visible')) {
                    associatedTab.slideUp('1000');
                    associatedTab.attr('aria-hidden', 'aria-hidden');
                    parent.removeClass('active');
                }
                else {
                    $(associatedTab).slideDown('1000', function () {
                        associatedTab.removeAttr('aria-hidden');
                        parent.addClass('active');
                    });
                }
            });

            if ($(window).width() < 768) {
                $('.filterMobile a').click(function (e) {
                    e.preventDefault();
                    $('.filterSection').toggle();
                });
            }

            /*Cruise Blogs*/
            var searchPlaceholder = $(".blogInput").attr('placeholder');

            /*Mobile select*/
            $('#blogFilterSelect').on('change', function (e) {
                e.preventDefault();
                window.location.href = $("#blogFilterSelect option:selected").attr('value');
            });

            $(".blogInput").keyup(function () {
                if (this.selectionStart == 0) {
                    $(".searchBar").removeClass('selected');
                }
                else {
                    $(".searchBar").addClass('selected');

                }
            });

            $(".searchBar span").on("click", function (e) {
                e.preventDefault();
                $(".searchBar").removeClass('selected');
                $('.blogPageTitle').html($('.blogPageTitle').attr('data-title'));
            });
        }
    };
});
